import request from 'utils/Httprequest';
import axios from 'axios';

const server = '/api/braintrain-service-photon';

export default {
  tableFetchData({ url, method = 'post', data }) {
    return request({
      url,
      method,
      data,
    });
  },
  // 搜索学生列表
  queryStudentsList(data) {
    return request({
      url: `${server}/cyStudent/relation/selectPage`,
      method: 'POST',
      data,
    });
  },
  // 学生列表tabs标签数据
  queryStudentsStatistics(data) {
    return request({
      url: `${server}/workbench/user/statistics`,
      method: 'POST',
      data,
    });
  },
  // 获取企微签名
  getWxSign(data) {
    const { jsapiTicket, url } = data;
    return request({
      url: `${server}/workbench/signature/get?jsapiTicket=${jsapiTicket}&url=${url}`,
      method: 'GET',
    });
  },
  // 检查光子客户端是否在线状态
  checkedIsOnline(data) {
    console.log('data', data);
    return request({
      url: `${server}/workbench/isOnline`,
      method: 'post',
      json: true,
      data: data,
    });
  },
  // 上传图片
  uploadFile(data) {
    console.log('data', data.get('file'));
    return request({
      url: `${server}/workbench/uploadFile`,
      method: 'post',
      // json: true,
      data: data,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
  findAllCommodity(data) {
    return request({
      url: `${server}/cyStudent/relation/findAllCommodity`,
      method: 'POST',
      data,
    });
  },
  // 查询所有课程
  selectAllSub() {
    return request({
      url: `${server}/cyStudent/relation/selectAllSub`,
      method: 'GET',
    });
  },
  // 学情-课程维度-根据课程id获取课程信息
  selectPlanContentList(data) {
    return request({
      url: `${server}/cyStudent/relation/selectPlanContentList`,
      method: 'POST',
      data,
    });
  },
  // cr学生列表
  selectPage(data) {
    return request({
      url: `${server}/cyStudent/relation/selectPage`,
      method: 'POST',
      data,
    });
  },
  // 获取用户基础信息
  getUserBaseInfo(token) {
    return request({
      url: `${server}/thirdPartAuth/ferrari/getUserBaseInfo?token=${token}`,
      method: 'GET',
    });
  },
};
